define('home/templates/spamAlert',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=depth0 != null ? depth0 : {}, alias2=container.escapeExpression;

  return "<div class=\"alert alert--error -spam align-min-tablet align--between align--middle\">\n<div class=\"spacing-narrow text-medium\">\n"
    + alias2(helpers.gettext.call(alias1,"This discussion might be spam, so it's hidden to other readers.",{"name":"gettext","hash":{},"data":data}))
    + "\n</div>\n<div class=\"spacing-narrow\">\n<button class=\"button button-inverted -hover-opaque button-padding-taller button-wide--mobile text-medium\" data-action=\"mark-approved\">\n"
    + alias2(helpers.gettext.call(alias1,"This isn't spam",{"name":"gettext","hash":{},"data":data}))
    + "\n</button>\n</div>\n</div>\n";
},"useData":true})

});
